import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Beatloader from '../../../../Common/Loaders/Beatloader';
import { toast } from 'react-toastify';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
const LedgerAccountView = ({
    loadingLedgerAccountDetail,
    LedgerAccountDetail,
    LedgerAccountDetailError,
    showLedgerDetail,
    handleCloseLedgerDetail
}) => {
    if (loadingLedgerAccountDetail) { return <Beatloader /> }
    if (LedgerAccountDetailError) {
        toast.error(LedgerAccountDetailError)
    }
    // console.log("LedgerAccountDetail", LedgerAccountDetail)
    if (LedgerAccountDetail && Object.keys(LedgerAccountDetail).length) {
        return (
            <>
                <Modal
                    size="xl"
                    show={showLedgerDetail}
                    onHide={handleCloseLedgerDetail}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{LedgerAccountDetail ? LedgerAccountDetail.ledger_party_name ?? "" : ""}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Tabs
                            defaultActiveKey="basic"
                            id="uncontrolled-tab-example"
                            className="mb-3"
                        >
                            <Tab eventKey="basic" title="Basic Info">
                                <table class="table">
                                    <tbody>
                                        <tr>
                                            <th scope="row">Ledger Code</th>
                                            <td>{LedgerAccountDetail?.ledger_code ?? ""}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Ledger Type</th>
                                            <td>{LedgerAccountDetail?.ledger_account_ledger_type ? LedgerAccountDetail.ledger_account_ledger_type.name ?? "" :""}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Party name</th>
                                            <td>{LedgerAccountDetail?.ledger_party_name ?? ""}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Group name</th>
                                            <td>Mark</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Sales Person</th>
                                            <td>{LedgerAccountDetail?.ledger_sales_person ?? ""}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Account Group</th>
                                            <td>Mark</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Opening Balance</th>
                                            <td>{LedgerAccountDetail?.ledger_opening_balance ?? ""}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Credit Limit</th>
                                            <td>{LedgerAccountDetail?.ledger_credit_limit ?? ""}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Credit Days</th>
                                            <td>{LedgerAccountDetail?.ledger_credit_day ?? ""}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">DR/CR</th>
                                            <td>{LedgerAccountDetail?.ledger_debit_or_credit ?? ""}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Tab>
                            <Tab eventKey="address" title="Address">
                                <div className="row">
                                    <h5>Address List</h5>
                                </div>
                                {
                                    LedgerAccountDetail && LedgerAccountDetail?.ledger_account_addresses && Array.isArray(LedgerAccountDetail?.ledger_account_addresses) && LedgerAccountDetail?.ledger_account_addresses.length ?
                                        LedgerAccountDetail.ledger_account_addresses.map((v, i) => {
                                            return <>
                                                <div className="row my-1 mx-2">
                                                    Address #{i + 1}
                                                </div>
                                                <table class="table">
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row">Address Line 1</th>
                                                            <td>{v.address_line_one ?? ""}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Address Line 2</th>
                                                            <td>{v.address_line_two ?? ""}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Country</th>
                                                            <td>{v.address_line_two ?? ""}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">State</th>
                                                            <td>{v.address_line_two ?? ""}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">City</th>
                                                            <td>{v.address_line_two ?? ""}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Pincode / ZIP</th>
                                                            <td>{v.address_line_two ?? ""}</td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </>
                                        })
                                        :
                                        <div className="row">
                                            <i>No address found.</i>
                                        </div>
                                }
                            </Tab>
                            <Tab eventKey="tax" title="Tax Details">
                                {
                                    LedgerAccountDetail && LedgerAccountDetail?.ledger_account_tax_details && Array.isArray(LedgerAccountDetail?.ledger_account_tax_details) && LedgerAccountDetail?.ledger_account_tax_details.length ?
                                        <>
                                            <table class="table">
                                                <tbody>
                                                    <tr>
                                                        <th scope="row">TDS Applicable</th>
                                                        <td>{LedgerAccountDetail?.ledger_account_tax_details[0].tds_applicable ?? ""}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">TDS Category</th>
                                                        <td>{LedgerAccountDetail?.ledger_account_tax_details[0].ledger_account_tax_detail_tds_category ?
                                                        LedgerAccountDetail?.ledger_account_tax_details[0].ledger_account_tax_detail_tds_category.name ?? "":""}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">TDS Percentage</th>
                                                        <td>{LedgerAccountDetail?.ledger_account_tax_details[0].tds_percentage ?? ""}</td>

                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Pan Number</th>
                                                        <td>{LedgerAccountDetail?.ledger_account_tax_details[0].pan_number ?? ""}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </>
                                        :
                                        <div className="row mx-2">
                                            <i>No data found.</i>
                                        </div>
                                }

                            </Tab>
                            <Tab eventKey="bank" title="Bank Details">
                                {
                                    LedgerAccountDetail && LedgerAccountDetail?.ledger_account_bank_details && Array.isArray(LedgerAccountDetail?.ledger_account_bank_details) && LedgerAccountDetail?.ledger_account_bank_details.length ?
                                        LedgerAccountDetail.ledger_account_bank_details.map((v, i) => {
                                            return <>
                                                <div className="row my-1 mx-2">
                                                    Bank Details #{i + 1}
                                                </div>
                                                <table class="table">
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row">Account Number</th>
                                                            <td>{v.account_number ?? ""}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">IFSC Code</th>
                                                            <td>{v.address_line_two ?? ""}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Bank Name</th>
                                                            <td>{v.bank_name ?? ""}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Branch Address</th>
                                                            <td>{v.address_line_two ?? ""}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </>
                                        })
                                        :
                                        <div className="row">
                                            <i>No address found.</i>
                                        </div>
                                }
                            </Tab>
                            <Tab eventKey="contact" title="Contact Info">
                                {
                                    LedgerAccountDetail && LedgerAccountDetail?.ledger_account_contacts && Array.isArray(LedgerAccountDetail?.ledger_account_contacts) && LedgerAccountDetail?.ledger_account_contacts.length ?
                                        LedgerAccountDetail.ledger_account_contacts.map((v, i) => {
                                            return <>
                                                <div className="row my-1 mx-2">
                                                    Contact Details #{i + 1}
                                                </div>
                                                <table class="table">
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row">Contact Person</th>
                                                            <td>{v.contact_person ?? ""}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Mobile</th>
                                                            <td>{v.mobile_number ?? ""}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Email</th>
                                                            <td>{v.email ?? ""}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Address</th>
                                                            <td>{v.address_line_two ?? ""}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Country</th>
                                                            <td>{v.address_line_two ?? ""}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">State</th>
                                                            <td>{v.address_line_two ?? ""}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">City</th>
                                                            <td>{v.address_line_two ?? ""}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Pincode</th>
                                                            <td>{v.address_line_two ?? ""}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </>
                                        })
                                        :
                                        <div className="row">
                                            <i>No address found.</i>
                                        </div>
                                }
                            </Tab>
                        </Tabs>
                    </Modal.Body>
                </Modal>
            </>
        )
    }
}

export default LedgerAccountView